/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useEffect, useContext } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { HrFlexContainer, HrInputText, HrLabel, HrParagraph, HrRed } from '@components/styles/hr-styles';
import { get } from 'lodash';
import { preferredPhoneCountries, customCountriesLabel } from '../../utilities/utilities';
import { DisplaySettingsContext } from '../../../postulation_form/store/display-settings';

export const InputPhone = ({
  title,
  name,
  prefix,
  placeholder,
  validate,
  formState,
  register,
  control,
  disabled,
  errorPosition,
  prefixValue
}) => {
  const validateRegister = {};
  const { errors } = formState;

  const refCurrent = useRef(null);
  const err = get(errors, name);
  useEffect(() => {
    if (err) {
      refCurrent.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      refCurrent.current?.focus();
    }
  }, [err]);

  if (validate.required) {
    validateRegister.required = 'Campo obligatorio';
  }
  if (validate.maxLength > 0) {
    validateRegister.maxLength = { value: validate.maxLength, message: `Máximo ${validate.maxLength} caracteres` };
  }
  if (validate.minLength > 0) {
    validateRegister.minLength = { value: validate.minLength, message: `Mínimo ${validate.minLength} caracteres` };
  }
  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <HrFlexContainer flexDirection='column' gap='8px' alignItems='flex-end' ref={refCurrent}>
      {title && (
        <HrFlexContainer justifyContent='space-between'>
          <HrLabel fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''} htmlFor={name} isRequired={validate.required} userSelect='none'>
            {title}
          </HrLabel>
          {errorPosition === 'top' && (
            <ErrorMessage
              errors={errors}
              name={name}
              render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
            />
          )}
        </HrFlexContainer>
      )}
      <HrFlexContainer flexWrap='nowrap' gap='8px'>
        <Controller
          name={prefix}
          control={control}
          rules={{ required: validate.required }}
          defaultValue={prefixValue}
          render={({ field }) => {
            return (
              <PhoneInput
                onChange={(value) => {
                  field.onChange(value);
                }}
                containerStyle={{
                  width: 'auto',
                  height: '40px',
                  background: '#FFFFFF',
                  borderRadius: '8px',
                  border: '1px solid #DADADA',
                  color: '#3B3F51',
                  boxSizing: 'border-box'
                }}
                inputStyle={{
                  background: darkMode ? '#1A1D2B' : '',
                  color:  darkMode ? 'white' : '',
                  width: '100px',
                  height: '100%',
                  borderRadius: '8px',
                  border: 'none',
                  padding: '0 0 0 48px'
                }}
                buttonStyle={{
                  background: darkMode ? '#1A1D2B' : 'white' ,
                  borderRadius: '8px',
                  border: 'none'
                }}
                searchStyle={{
                  background: 'white',
                  width: 'auto',
                  height: '100%',
                  borderRadius: '8px'
                }}
                buttonClass='phoneInputButton'
                inputProps={{
                  id: name,
                  name,
                  readOnly: true
                }}
                preferredCountries={preferredPhoneCountries}
                preserveOrder={['preferredCountries']}
                localization={customCountriesLabel}
                enableSearch
                disableSearchIcon
                searchPlaceholder='Nombre del país'
                country='ar' // Default value if prefix value is not recognized by library
                value={prefixValue}
              />
            );
          }}
        />
        <HrInputText
          background={ darkMode ? '#1A1D2B' : ''}
          color={ darkMode ? 'white' : '' }
          id={name}
          name={name}
          type='number'
          placeholder={placeholder}
          {...register(name, validateRegister)}
          disabled={disabled}
          className={errors[name] ? 'error' : ''}
        />
      </HrFlexContainer>
      {errorPosition === 'bottom' && (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
        />
      )}
    </HrFlexContainer>
  );
};

InputPhone.defaultProps = {
  errorPosition: 'top'
};
